import { countries } from './';

// ----------------------------------------------------------------------

const countryCache = {};

export function getCountryData(inputValue, defaultCountryData) {
  if (countryCache[inputValue]) return countryCache[inputValue];

  const countryData =
    countries.find(
      ({ code, name, phone, keywords }) =>
        name === inputValue ||
        keywords?.includes(inputValue) ||
        code === inputValue ||
        phone === inputValue
    ) ?? defaultCountryData;

  countryCache[inputValue] = countryData;

  return countryData;
}
